import React, { ComponentType } from 'react';
import { Skeleton } from '@mui/material';

interface Props {}

export const MainTableSkeleton: ComponentType<Props> = () => {
  return (
    <>
      <div className={'p-[0px] relative z-10 bg-[#fff]'}>
        <Skeleton
          variant="rectangular"
          sx={{ marginBottom: 2 }}
          animation={'wave'}
          height={50}
        />

        <div className={'p-[10px]'}>
          <Skeleton variant="text" animation={'wave'} height={25} width={150} />
          <Skeleton
            variant="rounded"
            sx={{ marginBottom: 1 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton variant="text" animation={'wave'} height={25} width={200} />
          <Skeleton
            variant="rounded"
            sx={{ marginBottom: 1 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton variant="text" animation={'wave'} height={25} width={100} />
          <Skeleton
            variant="rounded"
            sx={{ marginBottom: 1 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton variant="text" animation={'wave'} height={25} width={125} />
          <Skeleton
            variant="rounded"
            sx={{ marginBottom: 1 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="text"
            animation={'wave'}
            height={25}
            width={150}
            sx={{ opacity: 0.8 }}
          />
          <Skeleton
            variant="rounded"
            sx={{ marginBottom: 1, opacity: 0.8 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="text"
            animation={'wave'}
            height={25}
            width={110}
            sx={{ opacity: 0.6 }}
          />
          <Skeleton
            variant="rounded"
            sx={{ marginBottom: 1, opacity: 0.6 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="text"
            animation={'wave'}
            height={25}
            width={120}
            sx={{ opacity: 0.4 }}
          />
          <Skeleton
            variant="rounded"
            sx={{ marginBottom: 1, opacity: 0.4 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="text"
            animation={'wave'}
            height={25}
            width={150}
            sx={{ opacity: 0.2 }}
          />
          <Skeleton
            variant="rounded"
            sx={{ marginBottom: 1, opacity: 0.2 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="text"
            animation={'wave'}
            height={25}
            width={180}
            sx={{ opacity: 0.1 }}
          />
          <Skeleton
            variant="rounded"
            sx={{ marginBottom: 1, opacity: 0.1 }}
            animation={'wave'}
            height={40}
          />
        </div>
      </div>
    </>
  );
};
